<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        อัปโหลดไฟล์
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการข้อมูลโทรศัพท์เคลื่อนที่
          </a>
        </li>
        <li class="active">อัปโหลดไฟล์</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <!-- <h3 class="box-title">Hover Data Table</h3> -->
                <h3 class="box-title">ผลการนำเข้าข้อมูลไฟล์นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</h3>
              </div>

              <div class="box-body">
                <div class="wrapper_confirm_promotion">
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="success"
                    @click="submitUpload"
                  >ยืนยันการนำเข้าข้อมูล</el-button>
                  <el-button
                    style="margin-left: 10px;"
                    size="small"
                    type="primary"
                    @click="cancelUpload"
                  >ยกเลิก</el-button>
                </div>
                <div class="tablelist">

                  <el-table :data="tableShow" style="width: 100%">
                    <el-table-column prop="number"
                                     label="ลำดับ"
                                     width="80">
                    </el-table-column>
                    <el-table-column prop="operator" label="ผู้ให้บริการ" width="100">
                    </el-table-column>
                    <el-table-column prop="name_Promotion" label="ชื่อรายการส่งเสริมการขาย" width="200">
                    </el-table-column>
                    <el-table-column prop="price" label="ราคา">
                    </el-table-column>
                    <el-table-column prop="condition" label="เงื่อนไข">
                    </el-table-column>
                    <el-table-column prop="namePic" label="รูปภาพ" width="150">
                      <template slot-scope="scope">
                          <div class="img-radius">
                            <img
                              src="https://us.hola.com/en/imagenes/lifestyle/2017120810920/russian-girl-most-beautiful-in-world/0-17-240/anastasia-most-beautiful-t.jpg"
                              alt
                            >
                          </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="date" label="วันที่นำเข้าข้อมูล">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectDate: '',
      type: '',
      tableProps: {
        border: true
        // stripe: true,
      },
      tableShow: [
        {
          number: '1',
          operator: 'NBTC',
          name_Promotion: 'ปกติ',
          price: '05/07/2562 09.30',
          condition: 'ปกติ',
          namePic: 'ปกติ',
          date: '09/7/2562'
        },
        {
          number: '2',
          operator: 'NBTC',
          name_Promotion: 'ปกติ',
          price: '05/07/2562 09.30',
          condition: 'ปกติ',
          namePic: 'ปกติ',
          date: '09/7/2562'
        },
        {
          number: '3',
          operator: 'NBTC',
          name_Promotion: 'ปกติ',
          price: '05/07/2562 09.30',
          condition: 'ปกติ',
          namePic: 'ปกติ',
          date: '09/7/2562'
        },
        {
          number: '4',
          operator: 'NBTC',
          name_Promotion: 'ปกติ',
          price: '05/07/2562 09.30',
          condition: 'ปกติ',
          namePic: 'ปกติ',
          date: '09/7/2562'
        },
      ]
    }
  },
  methods: {
    submitUpload() {
      this.$router.push({ name: 'Alert_promotion_mobile' });
    },
    cancelUpload() {
      this.$router.push({ name: 'Add_uploadsave' });
    }
  }
};
</script>
